import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxsModule } from '@ngxs/store';
import { AbTestDirective } from '@x/common/ab-test/ab-test.directive';
import { FormCommonModule } from '@x/common/form';
import { LinkModule } from '@x/common/link';
import { LoaderModule } from '@x/common/loader/loader.module';
import { MediaThumbnailComponent } from '@x/common/media-thumbnail/media-thumbnail.component';
import { OperationModule } from '@x/common/operation';
import { AssociationModule } from '@x/ecommerce-shop/app/core/association/association.module';
import { OrderAbandonDialogComponent } from '@x/ecommerce-shop/app/core/order/components/order-abandon-dialog/order-abandon-dialog.component';
import { OrderBagButtonComponent } from '@x/ecommerce-shop/app/core/order/components/order-bag-button/order-bag-button.component';
import { OrderBagOverlayComponent } from '@x/ecommerce-shop/app/core/order/components/order-bag-overlay/order-bag-overlay.component';
import { OrderIsAwaitingPaymentDialogComponent } from '@x/ecommerce-shop/app/core/order/components/order-is-awaiting-payment-dialog/order-is-awaiting-payment-dialog.component';
import { OrderIsPartiallyPaidDialogComponent } from '@x/ecommerce-shop/app/core/order/components/order-is-partially-paid-dialog/order-is-partially-paid-dialog.component';
import { OrderRecreateDialogComponent } from '@x/ecommerce-shop/app/core/order/components/order-recreate-dialog/order-recreate-dialog.component';
import { OrderSummaryComponent } from '@x/ecommerce-shop/app/core/order/components/order-summary/order-summary.component';
import { OrderTotalsComponent } from '@x/ecommerce-shop/app/core/order/components/order-totals/order-totals.component';
import { AbandonOrderService } from '@x/ecommerce-shop/app/core/order/services/abandon-order.service';
import { AddToCartService } from '@x/ecommerce-shop/app/core/order/services/add-to-cart.service';
import { OrderItemViewService } from '@x/ecommerce-shop/app/core/order/services/order-item-view.service';
import { OrderRecreateService } from '@x/ecommerce-shop/app/core/order/services/order-recreate.service';
import { ShopOrderState } from '@x/ecommerce-shop/app/core/order/state/shop-order.state';
import { RoutingModule } from '@x/ecommerce-shop/app/core/routing/routing.module';
import { ShopErrorModule } from '@x/ecommerce-shop/app/core/shop-error/shop-error.module';
import { CloseButtonModule } from '@x/ecommerce-shop/app/core/shop-ui/components/close-button/close-button.module';
import { PageLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/page-layout';
import { NeedHelpModule } from '@x/ecommerce-shop/app/core/shop-ui/components/need-help/need-help.module';
import { OverlayUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/overlay/overlay-ui.module';
import { ShopColorModule } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-color/shop-color.module';
import { ShopDialogUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-dialog-ui/shop-dialog-ui.module';
import { UrlModule } from '@x/ecommerce-shop/app/core/url/url.module';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { MembershipSharedModule } from '@x/ecommerce-shop/app/membership/membership-shared.module';
import { IconUiModule } from '../shop-ui/components/icon-ui/icon-ui.module';
import { OrderInvoiceDownloadDialogComponent } from './components/order-invoice-download-dialog/order-invoice-download-dialog.component';
import { OrderRecreateButtonComponent } from './components/order-recreate-button/order-recreate-button.component';
import { OrderRecreateErrorDialogComponent } from './components/order-recreate-error-dialog/order-recreate-error-dialog.component';

@NgModule({
  providers: [AddToCartService, OrderItemViewService, AbandonOrderService, OrderRecreateService],
  declarations: [
    OrderBagOverlayComponent,
    OrderBagButtonComponent,
    OrderAbandonDialogComponent,
    OrderRecreateDialogComponent,
    OrderRecreateButtonComponent,
    OrderRecreateErrorDialogComponent,
    OrderIsPartiallyPaidDialogComponent,
    OrderInvoiceDownloadDialogComponent,
    OrderIsAwaitingPaymentDialogComponent,
  ],
  imports: [
    CommonModule,
    NgxsModule.forFeature([ShopOrderState]),
    MatButtonModule,
    OverlayModule,
    MatBadgeModule,
    OverlayUiModule,
    LoaderModule,
    RouterModule,
    UrlModule,
    LinkModule,
    UtilsModule,
    RoutingModule,
    OperationModule,
    FontAwesomeModule,
    MatTooltipModule,
    MembershipSharedModule,
    IconUiModule,
    NeedHelpModule,
    PageLayoutModule,
    MatInputModule,
    ReactiveFormsModule,
    FormCommonModule,
    CloseButtonModule,
    ShopDialogUiModule,
    ShopColorModule,
    ShopErrorModule,
    AssociationModule,
    AbTestDirective,
    MediaThumbnailComponent,
    OrderSummaryComponent,
    OrderTotalsComponent,
  ],
  exports: [
    OrderBagOverlayComponent,
    OrderBagButtonComponent,
    OrderAbandonDialogComponent,
    OrderRecreateDialogComponent,
    OrderRecreateButtonComponent,
  ],
})
export class OrderModule {}
